import Component from './instagram_applicant.vue'
export default Component
